
import { useEffect, useState } from 'react';

export const useVisibilityChange = () => {
  const [isFocused, setIsFocused] = useState(true)

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setIsFocused(true)
      } else {
        setIsFocused(false)
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isFocused
};
